module.exports = __webpack_public_path__ + "static/20180726_202321(0)_optimized-23fb947228dba33af4600c31b8299a35.jpg";